import React from "react";
import { Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";

function CashWithDrawalNotes({  }) {

  return (
      <div className="mt-4 note-disclaimer-container">
        <div className="p-3 p-lg-4 pt-3 tnc-content disable-scroll">
          <div className="text-bold-600">*Notes:</div>
          <Table className="withdrawal-table mt-2">
            <tr>
              <th style={{textAlign: "center"}} colSpan={2}>Request Submit On</th>
              <th style={{textAlign: "center"}}>Funds Available at Beneficiary Bank</th>
            </tr>
            <tr>
              <td>Day</td>
              <td>Time</td>
              <td></td>
            </tr>
            <tr>
              <td rowSpan={2}>Business Day <br/>Monday to Friday</td>
              <td>Before 12pm</td>
              <td>By 12.30pm, Next Business Day</td>
            </tr>
            <tr>

              <td>After 12pm</td>
              <td>By 12.30pm, Next 2 Business Day</td>
            </tr>
            <tr>
              <td>Non-Business Day <br/> Saturday, Sunday & Federal Territory Public Holiday</td>
              <td>Anytime</td>
              <td>By 12.30pm, Next 2 Business Day</td>
            </tr>
          </Table>
        </div>
      </div>
  );
}

export default CashWithDrawalNotes;
